export const CAT_BANNER_ICON_TYPES = {
    ERROR: 'error',
    SUCCESS: 'success',
    WARNING: 'warning'
  }